<template>
  <div>
    <!--
    {{ details }}
-->
    <table>
      <tr v-show="details?.getBooleanValue(PersonDetailsId.OrderingBlocking)">
        <td colspan="2">
          <span
            class="e-badge e-badge-danger e-badge-pill"
          >          Bestellmöglichkeit gesperrt</span>
        </td>
      </tr>
      <tr>
        <td>Rechnungstyp</td>
        <td>
          <SogDataLabel
            :value="_orderType"
          />
        </td>
      </tr>
      <tr>
        <td>Rechnungsreferenznummer</td>
        <td>
          <SogDataLabel :value="details?.getValue(PersonDetailsId.InvoiceCircle)" />
        </td>
      </tr>
      <tr v-show="_accountStore.hasAccountingLicense() && details?.getValue(PersonDetailsId.OrderTypeId)">
        <td>Rechnungs-Email</td>
        <td>
          <SogDataLabel :value="details?.getValue(PersonDetailsId.OrderEmail)" />
        </td>
      </tr>
      <tr v-show="_accountStore.hasAccountingLicense() && details?.getValue(PersonDetailsId.OrderTypeId)">
        <td>Kreditlimit</td>
        <td>
          <SogDataLabel
            v-show="!(details?.getBooleanValue(PersonDetailsId.WithoutCreditLimit))"
            :value="details?.getNumberValue(PersonDetailsId.CreditLimit)"
            :value-type="SogDataLabelValueType.Money"
          />
          <SogDataLabel
            v-show="details?.getBooleanValue(PersonDetailsId.WithoutCreditLimit)"
            value="ohne"
          />
        </td>
      </tr>

      <tr v-show="details?.getValue(PersonDetailsId.OrderTypeId) === 'AccumulativeInvoice'">
        <td>Automatische Stornoabrechnung</td>
        <td>
          <SogDataLabel
            :value="details?.getValue(PersonDetailsId.AutomaticCancelationInvoicing) === 'False' ? 'Nein' : 'Ja'"
          />
        </td>
      </tr>

      <tr v-show="details?.getValue(PersonDetailsId.OrderTypeId) === 'AccumulativeInvoice'">
        <td>Stornogenehmigung ohne Bezahlung</td>
        <td>
          <SogDataLabel
            :value="details?.getValue(PersonDetailsId.CancellationAllowedWithoutPayment) === 'True' ? 'Ja' : 'Nein'"
          />
        </td>
      </tr>

      <tr v-show="details?.getValue(PersonDetailsId.OrderTypeId)">
        <td>Rechnungsfälligkeit</td>
        <td>
          <SogDataLabel :value="details?.getValue(PersonDetailsId.InvoiceDueDate)" />
        </td>
      </tr>
      <tr v-show="details?.getValue(PersonDetailsId.OrderTypeId) === 'AccumulativeInvoice'">
        <td>Nächste Rechnung am</td>
        <td>
          <SogDataLabel
            :value="details?.getValue(PersonDetailsId.OrderScheduleNext)"
            :value-type="SogDataLabelValueType.DateTime"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">


import {computed} from "vue";
import {orderTypeDescription} from "@/shared/model/orderType";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import PersonDetails from "@/shared/model/personDetails";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import {useAccountStore} from "@/stores/accountStore";

interface Props {
  details?: PersonDetails
}

const props = withDefaults(defineProps<Props>(), {
    details: undefined
  }
)

const _accountStore = useAccountStore();

const _orderType = computed(() => {
  return orderTypeDescription(props.details?.getValue(PersonDetailsId.OrderTypeId));
})


</script>

<style scoped>

td {
  padding-right: 10px;
}


</style>
